import EcoImg from 'eco-design/base/eco-img';
import { Tooltip } from 'antd-v5';
import { useOnceInView } from '../useOnceInView';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';

const IMG = {
    us: {
        pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767842364365-5copv4-compressed-Frame%202094654992.jpg',
        pad: 'https://websiteoss.ecoflow.com/figma-uploads/1767842372559-uelx3i-compressed-Frame%202094654993.jpg',
        h5: 'https://websiteoss.ecoflow.com/figma-uploads/1767842378446-zuje4b-compressed-Frame%202094654994.jpg',
    },
    za: {
        pc: 'https://websiteoss.ecoflow.com/figma-uploads/1788924225858-ihndue-compressed-Frame%202094654992.webp',
        pad: 'https://websiteoss.ecoflow.com/figma-uploads/1788924254902-xd3hm3-compressed-Frame%202094654993.webp',
        h5: 'https://websiteoss.ecoflow.com/figma-uploads/1788924258786-pikbfu-compressed-Frame%202094654994.webp',
    },
};

function TheComp() {
    const { t } = useLang('theProduct');
    const { locale = 'us' } = getLocal();
    const img = IMG[locale as keyof typeof IMG] || IMG.us;

    const icons = [
        {
            icon: 'https://websiteoss.ecoflow.com/figma-uploads/1767580470446-6ngx6v-compressed-icon/phone.png',
            name: t('B_icon_phone'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/figma-uploads/1767580493497-7aa9wn-compressed-icon/laptop.png',
            name: t('B_icon_laptop'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/figma-uploads/1767580497610-endhkt-compressed-icon/light.png',
            name: t('B_icon_light'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/figma-uploads/1767580500617-0fapr9-compressed-icon/SUP%20Air%20Pump.png',
            name: t('B_icon_pump'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/figma-uploads/1767580503323-6qjng3-compressed-icon/projector.png',
            name: t('B_icon_projector'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/figma-uploads/1767580506801-k2irdt-compressed-icon/coffee_machine.png',
            name: t('B_icon_coffee'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/figma-uploads/1767580509433-qyvo02-compressed-icon/electric_grill.png',
            name: t('B_icon_grill'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/figma-uploads/1767580512438-f32o34-compressed-icon/kettle.png',
            name: t('B_icon_kettle'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/figma-uploads/1767580514604-bjtd4e-compressed-icon/car_frige.png',
            name: t('B_icon_fridge'),
        },
        {
            icon: 'https://websiteoss.ecoflow.com/figma-uploads/1767580517678-8kg122-compressed-icon/air_condition.png',
            name: t('B_icon_conditioner'),
        },
    ];

    useOnceInView('.on-the-road-B .B-title', () => {
        document.querySelector('.B-title')?.classList.add('enter');
        document.querySelector('.B-desc')?.classList.add('enter');
        document.querySelector('.B-content')?.classList.add('enter');
    });

    return (
        <section
            className={`${css.section} on-the-road-B GtmModuleData-section `}
            id="on-the-road-B"
            data-section-id={'on-the-road-B'}
            data-section-title={t('B_title')}
        >
            <div className="B-title ani-1">{t('B_title')}</div>
            <div className="B-desc ani-2">{t('B_desc')}</div>
            <div className="B-content ani-3">
                <div className="B-img-content">
                    <EcoImg pc={img.pc} pad={img.pad} h5={img.h5} isOpenLazy />
                    <Tooltip
                        getPopupContainer={(e) => e?.parentElement || e}
                        placement="top"
                        color="white"
                        title={
                            <>
                                <div className="tip-title">{t('B_item1_title')}</div>
                                <div className="tip-desc">{t('B_item1_desc')}</div>
                            </>
                        }
                    >
                        <div className="B-img-content-tip tip1">{t('B_item1')}</div>
                    </Tooltip>
                    <Tooltip
                        getPopupContainer={(e) => e?.parentElement || e}
                        placement="top"
                        color="white"
                        title={
                            <>
                                <div className="tip-title">{t('B_item2_title')}</div>
                                <div className="tip-desc">{t('B_item2_desc')}</div>
                            </>
                        }
                    >
                        <div className="B-img-content-tip tip2">{t('B_item2')}</div>
                    </Tooltip>
                    <Tooltip
                        getPopupContainer={(e) => e?.parentElement || e}
                        placement="top"
                        color="white"
                        title={
                            <>
                                <div className="tip-title">{t('B_item3_title')}</div>
                                <div className="tip-desc">{t('B_item3_desc')}</div>
                            </>
                        }
                    >
                        <div className="B-img-content-tip tip3">{t('B_item3')}</div>
                    </Tooltip>
                </div>
                <div className="B-icon-content">
                    <div className="B-icon-list">
                        {icons.map((i, idx) => (
                            <div className="B-icon-list-item" key={idx}>
                                <img src={i.icon} alt="" loading="lazy" />
                                <div className="B-icon-name">{i.name}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default TheComp;
